import styled from "styled-components";

export const IntroTextWrapper = styled.div``;

export const IntroWrapper = styled.div`
  padding-top: 8vh;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: Share Tech, sans-serif;
  font-weight: 400;
  color: #2591cf;
`;

export const IntroTitleWrapper = styled.h2`
  font-size: min(230px, 20vw);
`;

export const IntroSubtitleWrapper = styled.h4`
  font-size: min(100px, 10vw);
  text-align: left;
`;
